import React from 'react';
import { Helmet } from "react-helmet";

const Cookies = (props) => {
  return (
    <Helmet>
      {/* Produção OptanonConsentNoticeStart */}
      <meta name="adopt-website-id" content="4689c940-2afa-4cb7-81c2-c3d954c4919c" />

      <script src="//tag.goadopt.io/injector.js?website_code=4689c940-2afa-4cb7-81c2-c3d954c4919c" class="adopt-injector"></script>      {/*OptanonConsentNoticeEnd */}
    </Helmet>
  )
};
export default Cookies;